import { render, staticRenderFns } from "./ztOrder.vue?vue&type=template&id=6264e2fa&scoped=true&"
import script from "./ztOrder.vue?vue&type=script&lang=js&"
export * from "./ztOrder.vue?vue&type=script&lang=js&"
import style0 from "./ztOrder.vue?vue&type=style&index=0&id=6264e2fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6264e2fa",
  null
  
)

export default component.exports